import { useEffect, useState } from "react"
import { useApolloClient } from "@apollo/react-hooks"

import image, { PRODUCT_PHOTOGRAMME } from "lacinetek-common/src/images"

import { useTranslation } from "lib/i18n/translation"
import { useModal } from "lib/modal"
import { MUTATE_UNSUBSCRIBE_INFORMATION, TOGGLE_ACCESS_MUTATION } from "lib/graphql"
import { useAccesses } from "lib/accesses"
import { useProducts } from "lib/products"
import { useLanguages } from "lib/languages"

import Image from "components/common/image"
import SkeletonLink from "components/common/skeleton-link"
import Loading from "components/films/loading"

import ConfirmTerminateSucceed from "./confirm-terminate-succeed"

const ConfirmTerminate = ({ access }) => {
	const { c } = useTranslation("common")
	const { current } = useLanguages()
	const { updateRecurringStateOfSubscription, subscription } = useAccesses()
	const { fetchProductsMostViewed, productsMostViewed, getFilms } = useProducts()
	const [filmsMostViewed, setFilmsMostViewed] = useState([])
	const { hide, show } = useModal()
	const client = useApolloClient()

	const [terminating, setTerminating] = useState(false)

	const terminate = async () => {
		setTerminating(true)

		const { data } = await client.mutate({ mutation: TOGGLE_ACCESS_MUTATION, variables: { id: access.id } })
		updateRecurringStateOfSubscription(data.toggleAccessRenewal)

		setTerminating(false)

		client
			.mutate({
				mutation: MUTATE_UNSUBSCRIBE_INFORMATION,
				variables: {
					unsubscribeInformation: {
						subscriptionId: parseInt(subscription.id),
						hasCancelled: true,
					}
				},
				context: { clientName: "adminKinow" }
			})

		show({
			id: "confirm-terminate-succeed",
			children: <ConfirmTerminateSucceed/>,
			className: "modal",
			canGoBack: false,
		})
	}

	const onClickOnFilm = (product) => {
		client
			.mutate({
				mutation: MUTATE_UNSUBSCRIBE_INFORMATION,
				variables: {
					unsubscribeInformation: {
						subscriptionId: parseInt(subscription.id),
						hasCancelled: false,
						productId: parseInt(product.id),
						productName: product.name,
					}
				},
				context: { clientName: "adminKinow" }
			})
	}

	useEffect(() => {
		let subscriptionIsoCode = "fr"

		if (subscription.isocode) {
			subscriptionIsoCode = subscription.isocode
		}

		if (!productsMostViewed) {
			fetchProductsMostViewed()
			return
		}

		getFilms(productsMostViewed[subscriptionIsoCode].map(p => p.productId), current, subscriptionIsoCode)
			.then(films => {
				setFilmsMostViewed(films.slice(0, 8))
			})
			.catch(error => {
				// FIXME handling error
				console.log(error)
			})
	}, [productsMostViewed, subscription])

	return (
		<>
			<h2 className="main-title">{c("before-leaving")}...</h2>
			<p className="introduction">{c("films-available-in-subscription")}</p>
			<ul className="grid films">
				{filmsMostViewed.length > 0
				? filmsMostViewed.map(product => product
					&& (
						<li className="item" key={product.name}>
							<div className="item-content">
								<SkeletonLink href="/film/[id]" as={`/film/${product.linkRewrite}`}>
									<a title="Voir la fiche film" className="more-link" onClick={() => onClickOnFilm(product)}>
										<span className="label">Voir la fiche film</span>
									</a>
								</SkeletonLink>
								<div className="film-link">
									<figure className="cover">
										<picture>
											<Image
												src={image(product, PRODUCT_PHOTOGRAMME)}
												alt={product.name}
												height={353}
												width={588}
												/>
										</picture>
									</figure>
								<div className="infos">
									<h3 className="title">{product.name}</h3>
									<span className="director">{product.director}</span>
									<span className="year">{product.year}</span>
									<span className="country">{product.origin}</span>
									<span className="duration">{product.duration}</span>
								</div>
								</div>
							</div>
						</li>
					)
				)
			: <Loading loaderColor={"white"}/>
			}
			</ul>
			<div className="overlay-footer fixed">
				<nav className="buttons centered limited">
					<a
						href="#"
						onClick={e => {
							e.preventDefault();
							hide()
						}}
						rel="nofollow noopener"
						title={c("preserve")}
						className="close"
						style={{ marginRight: "1rem" }}
						>
						{c("preserve")}
					</a>
					<a
						href="#"
						onClick={async (e) => {
							e.preventDefault();
							await terminate()
						}}
						rel="nofollow noopener"
						title={"cancel-subscription"}
						data-overlay="#overlay-add-svod-to-cart-remove-2"
						className={`outline ${terminating ? "is-loading" : ""}`}
						>
						{c("cancel-subscription")}
					</a>
				</nav>
			</div>
		</>
	)
}

export default ConfirmTerminate
